import React from 'react';

import { useTranslation } from 'react-i18next';
import { Modal, Button, Form, Input, Slider } from 'antd';

const formLayout = {
	labelCol: { span: 24 },
	wrapperCol: {
		span: 24,
	},
};

const marks = {
	1: 'Not at all',
	2: 'Partially',
	3: 'Highly',
};

export const ProjectModal = (props: any) => {
	const [form] = Form.useForm();
	const { t } = useTranslation();

	const handleFormSubmit = () => {
		console.log('handleFormSubmit');
		form.validateFields()
			.then((values) => {
				console.log('validated', values);
				props.onSave(values);
				props.onHide();
			})
			.catch((errorInfo) => {
				console.log('error', errorInfo);
			});
	};

	const footer = (
		<div style={{ display: 'flex' }}>
			<Button
				style={{ marginRight: 'auto' }}
				onClick={() => {
					props.onHide();
				}}
			>
				Cancel
			</Button>
			<Button onClick={handleFormSubmit} type="primary">
				Save
			</Button>
		</div>
	);

	return (
		<Modal
			visible={true}
			okButtonProps={{ style: { display: 'none' } }}
			onCancel={props.onHide}
			cancelText="Close"
			footer={footer}
			width={"calc( min(100%, 800px) )"}
		>
			<Form
				{...formLayout}
				form={form}
				onFinish={(values) => {
					props.onChange(props.id, values);
					props.onHide();
				}}
				initialValues={props.values}
				width={"calc( min(100%, 800px) )"}
			>
				<Form.Item name="name" required={true} label={t('models.project.fields.name_explanation')}>
					<Input></Input>
				</Form.Item>
				<Form.Item name="context" label={t('models.project.fields.context_explanation')}>
					<Input.TextArea rows={6}></Input.TextArea>
				</Form.Item>
				<Form.Item name="description" label={t('models.project.fields.description_explanation')}>
					<Input.TextArea rows={6}></Input.TextArea>
				</Form.Item>
				<Form.Item name="experienceLevel" label="How experienced are you in making this type of decision?">
					<Slider included={false} marks={marks} tooltip={{ open: false }} dots={false} min={1} max={3} />
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default ProjectModal;
